import React from 'react';

import {
  EmailDocument,
  Excel,
  ExcelTemplate,
  Image,
  LockedEmailDocument,
  LockedExcel,
  LockedPdf,
  LockedPowerPoint,
  LockedUnknownDocument,
  LockedWord,
  Mail,
  Note,
  Pdf,
  PowerPoint,
  PowerPointTemplate,
  Rtf,
  SignedPdf,
  Task,
  Text,
  UnknownDocument,
  Word,
  WordTemplate,
  ZipDocument,
} from '_/assets/images';
import i18n from '_/i18n';
import {ArtifactType} from '_/utilities/types';

export const DOCUMENT_ICONS_MAP: Record<ArtifactType, React.ReactElement> = {
  EMAIL: <Mail />,
  NOTE: <Note />,
  EMAIL_DOCUMENT: <EmailDocument />,
  EXCEL_DOCUMENT: <Excel />,
  PDF_DOCUMENT: <Pdf />,
  WORD_DOCUMENT: <Word />,
  POWERPOINT_DOCUMENT: <PowerPoint />,
  IMAGE_DOCUMENT: <Image />,
  TEXT_DOCUMENT: <Text />,
  RTF_DOCUMENT: <Rtf />,
  ZIP_DOCUMENT: <ZipDocument />,
  UNKNOWN_DOCUMENT: <UnknownDocument />,
  TASK: <Task />,
};

export const OFFICE_TEMPLATES_ICONS_MAP: Record<
  'EXCEL_DOCUMENT' | 'WORD_DOCUMENT' | 'POWERPOINT_DOCUMENT',
  React.ReactElement
> = {
  EXCEL_DOCUMENT: <ExcelTemplate />,
  WORD_DOCUMENT: <WordTemplate />,
  POWERPOINT_DOCUMENT: <PowerPointTemplate />,
};

export const ARTIFACT_TYPE_TRANSLATIONS: Record<ArtifactType, string> = {
  TASK: i18n.t('documents:fileList.fileType.task'),
  EMAIL: i18n.t('documents:fileList.fileType.email'),
  NOTE: i18n.t('documents:fileList.fileType.note'),
  EMAIL_DOCUMENT: i18n.t('documents:fileList.fileType.emailDocument'),
  EXCEL_DOCUMENT: i18n.t('documents:fileList.fileType.excel'),
  PDF_DOCUMENT: i18n.t('documents:fileList.fileType.pdf'),
  WORD_DOCUMENT: i18n.t('documents:fileList.fileType.word'),
  POWERPOINT_DOCUMENT: i18n.t('documents:fileList.fileType.powerpoint'),
  IMAGE_DOCUMENT: i18n.t('documents:fileList.fileType.image'),
  TEXT_DOCUMENT: i18n.t('documents:fileList.fileType.text'),
  RTF_DOCUMENT: i18n.t('documents:fileList.fileType.rtf'),
  ZIP_DOCUMENT: i18n.t('documents:fileList.fileType.zip'),
  UNKNOWN_DOCUMENT: i18n.t('documents:fileList.fileType.unknown'),
};

export const SIGNED_DOCUMENT_ICONS_MAP: Record<
  ArtifactType,
  React.ReactElement
> = {
  ...DOCUMENT_ICONS_MAP,
  PDF_DOCUMENT: <SignedPdf />,
};

export const LOCKED_DOCUMENT_ICONS_MAP: Record<
  ArtifactType,
  React.ReactElement
> = {
  EMAIL: <LockedUnknownDocument />, // TODO LEXIAN-4878: No icon available (yet)
  NOTE: <Note />,
  EMAIL_DOCUMENT: <LockedEmailDocument />,
  EXCEL_DOCUMENT: <LockedExcel />,
  PDF_DOCUMENT: <LockedPdf />,
  WORD_DOCUMENT: <LockedWord />,
  POWERPOINT_DOCUMENT: <LockedPowerPoint />,
  IMAGE_DOCUMENT: <LockedUnknownDocument />, // TODO LEXIAN-4878: No icon available (yet)
  RTF_DOCUMENT: <LockedUnknownDocument />,
  TEXT_DOCUMENT: <LockedUnknownDocument />,
  ZIP_DOCUMENT: <LockedUnknownDocument />,
  UNKNOWN_DOCUMENT: <LockedUnknownDocument />,
  TASK: <Task />,
};
